import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-tech-thankyou',
  templateUrl: './tech-thankyou.component.html',
  styleUrls: ['./tech-thankyou.component.scss']
})
export class TechThankyouComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  goBackPage() {
    this.router.navigate(['/provider-list']);
  }
}
